/**
 * @generated SignedSource<<0060af6742328997d82ae0b60c799874>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HpSharedLayout_viewer$data = {
  readonly homepage: {
    readonly modules: ReadonlyArray<{
      readonly index?: number | null;
      readonly messages?: {
        readonly items: ReadonlyArray<{
          readonly __typename: "PromoItem";
        } | null> | null;
      } | null;
      readonly type?: string | null;
      readonly visible?: boolean | null;
      readonly " $fragmentSpreads": FragmentRefs<"HpSharedCollectionsModule_componentModule" | "HpSharedEditorialModule_componentModule" | "HpSharedFeaturedBannerModule_componentModule" | "HpSharedPromoModule_componentModule" | "HpSharedShopByModule_componentModule" | "HpSharedTopHeroBannerModule_componentModule" | "HpSharedVideoComponent_componentModule">;
    } | null> | null;
    readonly personalization?: {
      readonly " $fragmentSpreads": FragmentRefs<"HpSharedNewArrivals_personalization">;
    } | null;
    readonly personalizationCollections?: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"HpSharedNewArrivalsCarouselTabs_personalizationCollections">;
    } | null> | null;
  } | null;
  readonly user?: {
    readonly hasLoggedInWithApp: boolean | null;
    readonly " $fragmentSpreads": FragmentRefs<"HpSharedAppBanner_user" | "HpSharedFeaturedModule_user" | "HpSharedHeroModule_user" | "HpSharedLocationsModule_user" | "HpSharedNewArrivalsTabContent_user" | "HpSharedNewArrivals_user" | "HpSharedTopHeroBannerModule_user" | "HpSharedTrendingNowCarouselTabs_user" | "HpSharedUserRecommendations_user" | "HpSharedVideoComponent_user">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedFeaturedModule_viewer" | "HpSharedHeroModule_viewer" | "HpSharedLocationsModule_viewer" | "HpSharedNewArrivalsTabContent_viewer" | "HpSharedNewArrivals_viewer" | "HpSharedTopHeroBannerModule_viewer" | "HpSharedTrendingNowCarouselTabs_viewer" | "HpSharedVideoComponent_viewer">;
  readonly " $fragmentType": "HpSharedLayout_viewer";
};
export type HpSharedLayout_viewer$key = {
  readonly " $data"?: HpSharedLayout_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedLayout_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v1 = {
  "kind": "Variable",
  "name": "userId",
  "variableName": "userId"
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "abTestList"
    },
    {
      "kind": "RootArgument",
      "name": "fetchInitialHomepage"
    },
    {
      "kind": "RootArgument",
      "name": "hasUserId"
    },
    {
      "kind": "RootArgument",
      "name": "homepageId"
    },
    {
      "kind": "RootArgument",
      "name": "isClient"
    },
    {
      "kind": "RootArgument",
      "name": "isEvergreenCollectionsTestVariant"
    },
    {
      "kind": "RootArgument",
      "name": "isNewArrivalsCarouselTabsTestVariant"
    },
    {
      "kind": "RootArgument",
      "name": "isRemoveShopByTestVariant"
    },
    {
      "kind": "RootArgument",
      "name": "isRemoveTopHeroBannerTestVariant"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    },
    {
      "kind": "RootArgument",
      "name": "userType"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpSharedLayout_viewer",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "abTestList",
          "variableName": "abTestList"
        },
        {
          "kind": "Variable",
          "name": "rootId",
          "variableName": "homepageId"
        }
      ],
      "concreteType": "Homepage",
      "kind": "LinkedField",
      "name": "homepage",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "modules",
          "plural": true,
          "selections": [
            {
              "condition": "isRemoveTopHeroBannerTestVariant",
              "kind": "Condition",
              "passingValue": false,
              "selections": [
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v0/*: any*/),
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "HpSharedTopHeroBannerModule_componentModule"
                    }
                  ],
                  "type": "TopHeroBannerModule",
                  "abstractKey": null
                }
              ]
            },
            {
              "condition": "fetchInitialHomepage",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v0/*: any*/),
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "HpSharedCollectionsModule_componentModule"
                    }
                  ],
                  "type": "CollectionsModule",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v0/*: any*/),
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "HpSharedEditorialModule_componentModule"
                    }
                  ],
                  "type": "EditorialModule",
                  "abstractKey": null
                }
              ]
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "index",
                  "storageKey": null
                },
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": [
                    {
                      "kind": "Variable",
                      "name": "userType",
                      "variableName": "userType"
                    }
                  ],
                  "concreteType": "PromoModuleMessages",
                  "kind": "LinkedField",
                  "name": "messages",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "PromoItem",
                      "kind": "LinkedField",
                      "name": "items",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "__typename",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "HpSharedPromoModule_componentModule"
                }
              ],
              "type": "PromoModule",
              "abstractKey": null
            },
            {
              "condition": "isRemoveShopByTestVariant",
              "kind": "Condition",
              "passingValue": false,
              "selections": [
                {
                  "condition": "isClient",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        (v0/*: any*/),
                        {
                          "args": null,
                          "kind": "FragmentSpread",
                          "name": "HpSharedShopByModule_componentModule"
                        }
                      ],
                      "type": "ShopByModule",
                      "abstractKey": null
                    }
                  ]
                }
              ]
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v0/*: any*/)
              ],
              "type": "LocationsModule",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "visible",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "HpSharedFeaturedBannerModule_componentModule"
                }
              ],
              "type": "BottomBannerModule",
              "abstractKey": null
            },
            {
              "condition": "isClient",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v0/*: any*/),
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "HpSharedVideoComponent_componentModule"
                    }
                  ],
                  "type": "VideoModule",
                  "abstractKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "condition": "hasUserId",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "alias": null,
              "args": [
                {
                  "kind": "Literal",
                  "name": "first",
                  "value": 3
                },
                {
                  "kind": "Literal",
                  "name": "numItems",
                  "value": 3
                },
                (v1/*: any*/)
              ],
              "concreteType": "PersonalizationModuleConnection",
              "kind": "LinkedField",
              "name": "personalization",
              "plural": false,
              "selections": [
                {
                  "condition": "isNewArrivalsCarouselTabsTestVariant",
                  "kind": "Condition",
                  "passingValue": false,
                  "selections": [
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "HpSharedNewArrivals_personalization"
                    }
                  ]
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": [
                {
                  "kind": "Literal",
                  "name": "numItems",
                  "value": 10
                },
                {
                  "kind": "Literal",
                  "name": "pageSize",
                  "value": 3
                },
                (v1/*: any*/)
              ],
              "concreteType": "PersonalizationCollectionType",
              "kind": "LinkedField",
              "name": "personalizationCollections",
              "plural": true,
              "selections": [
                {
                  "condition": "isNewArrivalsCarouselTabsTestVariant",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "HpSharedNewArrivalsCarouselTabs_personalizationCollections"
                    }
                  ]
                }
              ],
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HpSharedHeroModule_viewer"
    },
    {
      "condition": "isEvergreenCollectionsTestVariant",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "condition": "isClient",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "HpSharedTrendingNowCarouselTabs_viewer"
            }
          ]
        }
      ]
    },
    {
      "condition": "isEvergreenCollectionsTestVariant",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "condition": "isClient",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "HpSharedLocationsModule_viewer"
            }
          ]
        }
      ]
    },
    {
      "condition": "isNewArrivalsCarouselTabsTestVariant",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "HpSharedNewArrivals_viewer"
        }
      ]
    },
    {
      "condition": "isNewArrivalsCarouselTabsTestVariant",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "HpSharedNewArrivalsTabContent_viewer"
        }
      ]
    },
    {
      "condition": "isClient",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "HpSharedFeaturedModule_viewer"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "HpSharedVideoComponent_viewer"
        }
      ]
    },
    {
      "condition": "isRemoveTopHeroBannerTestVariant",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "HpSharedTopHeroBannerModule_viewer"
        }
      ]
    },
    {
      "condition": "hasUserId",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            (v1/*: any*/)
          ],
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            {
              "alias": "hasLoggedInWithApp",
              "args": [
                {
                  "kind": "Literal",
                  "name": "deviceType",
                  "value": "IOS_APP"
                }
              ],
              "kind": "ScalarField",
              "name": "hasLoggedInWithDeviceType",
              "storageKey": "hasLoggedInWithDeviceType(deviceType:\"IOS_APP\")"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "HpSharedHeroModule_user"
            },
            {
              "condition": "isEvergreenCollectionsTestVariant",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "HpSharedTrendingNowCarouselTabs_user"
                }
              ]
            },
            {
              "condition": "isEvergreenCollectionsTestVariant",
              "kind": "Condition",
              "passingValue": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "HpSharedLocationsModule_user"
                }
              ]
            },
            {
              "condition": "isNewArrivalsCarouselTabsTestVariant",
              "kind": "Condition",
              "passingValue": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "HpSharedNewArrivals_user"
                }
              ]
            },
            {
              "condition": "isNewArrivalsCarouselTabsTestVariant",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "HpSharedNewArrivalsTabContent_user"
                }
              ]
            },
            {
              "condition": "isClient",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "HpSharedVideoComponent_user"
                }
              ]
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "HpSharedFeaturedModule_user"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "HpSharedAppBanner_user"
            },
            {
              "condition": "isRemoveTopHeroBannerTestVariant",
              "kind": "Condition",
              "passingValue": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "HpSharedTopHeroBannerModule_user"
                }
              ]
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "HpSharedUserRecommendations_user"
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "8f869d302e302602229ca59418da4095";

export default node;
